import React, { useState } from "react";
import "./CulinaryConnectHero.css";
import chefImage from '../../Asset/Image/indianchef.jpg';

export default function CulinaryConnectHero() {
  const [searchTerm, setSearchTerm] = useState("");
  const [isHovered, setIsHovered] = useState(false);
  const [selectedCuisine, setSelectedCuisine] = useState("");

  const cuisines = ["South Indian", "North Indian", "Punjabi", "Mughlai", "Hyderabadi", "Gujarati", "Bengali", "Rajasthani"];

  const handleSearch = () => {
    if (searchTerm.trim() || selectedCuisine) {
      const searchQuery = selectedCuisine || searchTerm;
      alert(`Searching for chefs specializing in: ${searchQuery}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleCuisineSelect = (cuisine) => {
    setSelectedCuisine(cuisine);
    setSearchTerm(cuisine);
  };

  return (
    <section className="culinary-connect-hero">
      <div className="culinary-connect-container">
        <div className="culinary-connect-content">
          {/* Main Content */}
          <div className="culinary-connect-text">
            <div className="culinary-connect-badge">
              <span className="culinary-badge-icon">👑</span>
              <span>Trusted by 50,000+ Food Lovers Across India</span>
            </div>  

            <h1 className="culinary-connect-title">
              <span className="culinary-title-line">Experience Authentic</span>
              <span className="culinary-title-accent">Indian Home Cook</span>
              <span className="culinary-title-line">Delivered to Your Kitchen</span>
            </h1>

            <p className="culinary-connect-description">
              Transform your kitchen into a royal dastarkhwan with our handpicked culinary experts. 
              From intimate family dinners to grand celebrations, experience personalized regional menus crafted 
              just for you by India's top-rated home cooks.
            </p>

            {/* Quick Cuisine Selection */}
            <div className="culinary-cuisine-selection">
              <h3>Popular Regional Cuisines:</h3>
              <div className="culinary-cuisine-tags">
                {cuisines.map((cuisine) => (
                  <button
                    key={cuisine}
                    className={`culinary-cuisine-tag ${selectedCuisine === cuisine ? 'culinary-active' : ''}`}
                    onClick={() => handleCuisineSelect(cuisine)}
                  >
                    <span className="culinary-cuisine-icon">
                      {cuisine === "South Indian" && "🍛"}
                      {cuisine === "North Indian" && "🧆"}
                      {cuisine === "Punjabi" && "🍲"}
                      {cuisine === "Mughlai" && "🍗"}
                      {cuisine === "Hyderabadi" && "🍚"}
                      {cuisine === "Gujarati" && "🥘"}
                      {cuisine === "Bengali" && "🐟"}
                      {cuisine === "Rajasthani" && "🌾"}
                    </span>
                    {cuisine}
                  </button>
                ))}
              </div>
            </div>

            {/* Search Features */}
            <div className="culinary-connect-features">
              <div className="culinary-features-grid">
                <div className="culinary-feature-item">
                  <i className="fas fa-bolt"></i>
                  <span>Quick Booking</span>
                </div>
                <div className="culinary-feature-item">
                  <i className="fas fa-shield-alt"></i>
                  <span>Verified Chefs</span>
                </div>
                <div className="culinary-feature-item">
                  <i className="fas fa-star"></i>
                  <span>4.9/5 Rating</span>
                </div>
                <div className="culinary-feature-item">
                  <i className="fas fa-euro-sign"></i>
                  <span>Best Price</span>
                </div>
              </div>
            </div>
          </div>

          {/* Visual Section */}
          <div className="culinary-connect-visual">
            <div className="culinary-cards-container">
              {/* Main Chef Card */}
              <div className="culinary-main-chef-card">
                <div className="culinary-chef-image-container">
                  <img
                    src={chefImage}
                    alt="Master Chef Rajesh Kumar"
                    className="culinary-chef-image"
                  />
                  <div className="culinary-chef-badge">
                    <i className="fas fa-award"></i>
                    <span>Master Chef</span>
                  </div>
                  <div className="culinary-chef-availability">
                    <div className="culinary-availability-dot"></div>
                    <span>Available Today</span>
                  </div>
                  <div className="culinary-chef-experience">
                    <span>15+ Years</span>
                  </div>
                </div>
                <div className="culinary-chef-card-content">
                  <div className="culinary-chef-header">
                    <h3>Rajesh Kumar</h3>
                    <div className="culinary-chef-rating">
                      <i className="fas fa-star"></i>
                      <span>4.9</span>
                      <span className="culinary-rating-count">(247)</span>
                    </div>
                  </div>
                  <p className="culinary-chef-specialty">North Indian & Mughlai Expert</p>
                  <div className="culinary-chef-location">
                    <i className="fas fa-map-marker-alt"></i>
                    <span>Delhi NCR</span>
                  </div>
                  <div className="culinary-chef-skills">
                    <span className="culinary-skill-tag">🍛 Biryani Specialist</span>
                    <span className="culinary-skill-tag">🍢 Tandoori Master</span>
                    <span className="culinary-skill-tag">🧆 Curry Artisan</span>
                  </div>
                  <div className="culinary-chef-pricing">
                    <span className="culinary-price-from">From</span>
                    <span className="culinary-price-amount">£9.00</span>
                    <span className="culinary-price-meal">/meal</span>
                  </div>
                </div>
              </div>

              {/* Floating Meal Card */}
              <div className="culinary-floating-meal-card">
                <div className="culinary-meal-image-container">
                  <div className="culinary-meal-tag">Chef's Special</div>
                  <img
                    src="https://images.unsplash.com/photo-1565557623262-b51c2513a641?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGJpcnlhbml8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60"
                    alt="Hyderabadi Biryani"
                    className="culinary-meal-image"
                  />
                </div>
                <div className="culinary-meal-card-content">
                  <h4>Today's Special</h4>
                  <p>Authentic Hyderabadi Dum Biryani</p>
                  <div className="culinary-meal-details">
                    <span className="culinary-meal-time">⏱️ 60 min prep</span>
                    <span className="culinary-meal-serves">Serves 2-3</span>
                  </div>
                </div>
              </div>

              {/* Review Card */}
              <div className="culinary-floating-review-card">
                <div className="culinary-review-header">
                  <div className="culinary-reviewer-avatar">
                    <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fHByb2ZpbGV8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&w=500&q=60" alt="Priya S." />
                  </div>
                  <div className="culinary-reviewer-info">
                    <strong>Priya S.</strong>
                    <span>Mumbai</span>
                  </div>
                </div>
                <div className="culinary-review-stars">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fas fa-star"></i>
                  ))}
                </div>
                <p className="culinary-review-text">
                  "Chef Rajesh prepared the most authentic North Indian thali for our family gathering. 
                  The flavors took us back to our grandmother's kitchen!"
                </p>
                <div className="culinary-review-date">3 days ago</div>
              </div>

              {/* Booking Demo Card */}
              <div className="culinary-booking-demo-card">
                <div className="culinary-booking-header">
                  <i className="fas fa-calendar-check"></i>
                  <span>Simple 3-Step Booking</span>
                </div>
                <div className="culinary-booking-steps">
                  <div className="culinary-booking-step culinary-active">
                    <div className="culinary-step-number">1</div>
                    <span>Choose Chef & Menu</span>
                  </div>
                  <div className="culinary-booking-step">
                    <div className="culinary-step-number">2</div>
                    <span>Select Date & Time</span>
                  </div>
                  <div className="culinary-booking-step">
                    <div className="culinary-step-number">3</div>
                    <span>Enjoy Your Meal!</span>
                  </div>
                </div>
                <div className="culinary-booking-cta">
                  <button className="culinary-demo-book-btn">
                    <i className="fas fa-utensils"></i>
                    Book Your Experience
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}